import React from 'react';
import { beautyServices } from '../data/siteData';
import { BOOKING_URL } from '../data/siteData';
import logo from '../assets/logo.png';

const Services: React.FC = () => {
  return (
    <section id="services" className="services">
      <div className="container">

        {/* Header */}
        <div className="section-header">
          <p style={{ fontWeight: 600, fontSize: '0.8rem', color: '#ff1493', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 12 }}>
            Ne sunuyoruz?
          </p>
          <h2>Hizmetlerimiz</h2>
          <div className="section-divider" />
          <p>Uzman ekibimiz ve premium ürünlerimizle sunduğumuz güzellik hizmetlerini keşfedin.</p>
        </div>

        {/* Services grid — single category */}
        <div className="services-grid" style={{ gridTemplateColumns: '1fr', maxWidth: 800, margin: '0 auto' }}>
          <div className="service-category">
            <div className="category-header">
              <div className="category-logo">
                <img src={logo} alt="Bloome Beauty" />
              </div>
              <h3 className="category-title">
                <span className="pink">Bloome </span>
                <span className="black">Beauty </span>
                <span className="pink">Batıkent</span>
              </h3>
              <p className="category-subtitle">Tırnak · Kirpik · Kaş</p>
            </div>

            <div className="service-items" style={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
              {beautyServices.map((service) => (
                <div key={service.id} className="service-card">
                  <div className="service-icon">{service.icon}</div>
                  <h4>{service.name}</h4>
                  <p>{service.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA */}
        <div style={{ textAlign: 'center', marginTop: 48 }}>
          <p style={{ color: '#888', fontWeight: 300, marginBottom: 24, fontSize: '0.95rem' }}>
            Hangi hizmetin size uygun olduğundan emin değil misiniz?
          </p>
          <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              Randevu Al
            </a>
            <a href="#contact" className="btn btn-outline">
              Bize Ulaşın
            </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Services;
